import { render } from "./Songitem.vue?vue&type=template&id=16e8fb99"
import script from "./Songitem.vue?vue&type=script&lang=js"
export * from "./Songitem.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__